import {
  ExportCISStatementOfEarningsParams,
  ExportCISStatementOfEarningsResponse,
  SendMultipleMailCISStatementOfEarningsParams,
} from '@nxsys/types/api/report';
import {
  GetEarningStatementListParams,
  GetEarningStatementListResponse,
  ExportEarningStatementParams,
  ExportEarningStatementResponse,
} from '@nxsys/types/models/earningReport/v2';
import axios from '../axios';
import { endPoints } from '../endpoints';
import {
  ExportNowPensionParams,
  ExportNowPensionResponse,
  ExportPapdisPensionParams,
  ExportPapdisPensionResponse,
  ExportPensionIrelandParams,
  ExportPensionIrelandResponse,
  ExportPensionParams,
  ExportPensionResponse,
  GeneratePaymentFileParams,
  GeneratePaymentFileResponse,
  GetAutoEnrollmentStatusListParams,
  GetCISStateOfEarningsListParams,
  GetCISStateOfEarningsListResponse,
  GetDormantWorkerListParams,
  GetDormantWorkerListResponse,
  GetPensionContributionReportListParams,
  GetPensionContributionReportListResponse,
  GetNestExportPeriodParams,
  GetNestExportPeriodResponse,
  GetScheduleForApprovePaymentParams,
  GetScheduleForApprovePaymentResponse,
  GetSubmissionsForApprovePaymentParams,
  GetSubmissionsForApprovePaymentResponse,
  MarkAsSubmittedPensionParams,
  MarkAsSubmittedPensionResponse,
  ResubmitPensionParams,
  ResubmitPensionResponse,
  SaveP30P32SettingParams,
  SaveP30P32SettingResponse,
  SubmitPensionContributionReportParams,
  SubmitPensionContributionReportResponse,
  DownloadP30Params,
  DownloadP32Params,
  DownloadP30P32Response,
} from '@nxsys/store/slices/report/types';

export const sendMultipleMailCISStatementOfEarningsApi = async (
  params: SendMultipleMailCISStatementOfEarningsParams,
): Promise<{ success: boolean }> => {
  const response = await axios.put(
    endPoints.report.management.sendMultipleMailEarnings,
    params,
  );
  return response.data;
};

export const exportCISStatementOfEarningsApi = async (
  params: ExportCISStatementOfEarningsParams,
): Promise<ExportCISStatementOfEarningsResponse> => {
  const response = await axios.put(
    endPoints.report.management.exportEarning,
    {},
    { params },
  );
  return response.data;
};

export const getEarningReportListApi = async (
  params: GetCISStateOfEarningsListParams,
): Promise<GetCISStateOfEarningsListResponse> => {
  const response = await axios.get(endPoints.report.management.earning, {
    params,
  });
  return response.data;
};

export const getDormantWorkerListApi = async (
  params: GetDormantWorkerListParams,
): Promise<GetDormantWorkerListResponse> => {
  const response = await axios.get(endPoints.report.management.dormantWorker, {
    params,
  });
  return response.data;
};

export const exportPensionAssessedApi = async (
  params: GetAutoEnrollmentStatusListParams,
): Promise<any> => {
  const response = await axios.get(
    endPoints.report.pension.exportPensionAssessed,
    {
      params: {
        params: JSON.stringify(params),
      },
    },
  );
  return response.data;
};

export const exportNowPensionApi = async (
  params: ExportNowPensionParams,
): Promise<ExportNowPensionResponse> => {
  const response = await axios.post(
    endPoints.report.pension.exportNowPension,
    params,
  );
  return response.data;
};

export const exportPapdisPensionApi = async (
  params: ExportPapdisPensionParams,
): Promise<ExportPapdisPensionResponse> => {
  const response = await axios.post(
    endPoints.report.pension.exportPapdisPension,
    params,
  );
  return response.data;
};

export const exportPensionApi = async (
  params: ExportPensionParams,
): Promise<ExportPensionResponse> => {
  const response = await axios.post(
    endPoints.report.pension.exportPension,
    params,
  );
  return response.data;
};

export const getPensionContributionReportListApi = async (
  params: GetPensionContributionReportListParams,
): Promise<GetPensionContributionReportListResponse> => {
  const response = await axios.get(endPoints.report.pension.contributions, {
    params,
  });
  return response.data;
};

export const markAsSubmittedPensionApi = async (
  params: MarkAsSubmittedPensionParams,
): Promise<MarkAsSubmittedPensionResponse> => {
  const response = await axios.put(
    endPoints.report.pension.markSubmitted,
    params,
  );
  return response.data;
};

export const resubmitPensionApi = async (
  params: ResubmitPensionParams,
): Promise<ResubmitPensionResponse> => {
  const response = await axios.post(
    endPoints.report.pension.resubmitError,
    params,
  );
  return response.data;
};

export const submitPensionContributionReportApi = async (
  params: SubmitPensionContributionReportParams,
): Promise<SubmitPensionContributionReportResponse> => {
  const response = await axios.post(
    endPoints.report.pension.submitFromPayrolls,
    params,
  );
  return response.data;
};

export const getScheduleForApprovePaymentApi = async (
  params: GetScheduleForApprovePaymentParams,
): Promise<GetScheduleForApprovePaymentResponse> => {
  const response = await axios.get(
    endPoints.report.pension.getScheduleForApprovePayment,
    params,
  );
  return response.data;
};

export const getNestExportPeriodApi = async (
  params: GetNestExportPeriodParams,
): Promise<GetNestExportPeriodResponse> => {
  const response = await axios.get(
    endPoints.report.pension.getNestExportPeriod,
    { params },
  );
  return response.data;
};

export const getSubmissionsForApprovePaymentApi = async (
  params: GetSubmissionsForApprovePaymentParams,
): Promise<GetSubmissionsForApprovePaymentResponse> => {
  const response = await axios.get(
    endPoints.report.pension.getSubmissionsForApprovePayment,
    params,
  );
  return response.data;
};

export const approvePaymentApi = async (id: string): Promise<any> => {
  const response = await axios.post(
    endPoints.report.pension.approvePayment(id),
  );
  return response.data;
};

export const saveP30P32SettingApi = async (
  params: SaveP30P32SettingParams,
): Promise<SaveP30P32SettingResponse> => {
  const response = await axios.post(
    endPoints.hmrcRequest.P30P32.saveSettings,
    params,
  );
  return response.data;
};

export const downloadP30Api = async (
  params: DownloadP30Params,
): Promise<DownloadP30P32Response> => {
  const response = await axios.post(
    endPoints.hmrcRequest.P30P32.downloadP30,
    params,
  );
  return response.data;
};

export const downloadP32Api = async (
  params: DownloadP32Params,
): Promise<DownloadP30P32Response> => {
  const response = await axios.post(
    endPoints.hmrcRequest.P30P32.downloadP32,
    params,
  );
  return response.data;
};

export type P30P32DownloadStatusResponse = {
  status: 'pending' | 'processing' | 'completed' | 'failed';
  success?: boolean;
  link?: string;
  error?: string;
};

export const getP30P32DownloadStatusApi = async (
  jobId: number,
): Promise<P30P32DownloadStatusResponse> => {
  const response = await axios.get(
    endPoints.hmrcRequest.P30P32.downloadStatus(jobId),
  );
  return response.data;
};

export const generatePaymentFileApi = async (
  id: number,
  params: GeneratePaymentFileParams,
): Promise<GeneratePaymentFileResponse> => {
  const response = await axios.post(
    endPoints.report.bankFile.reDownload(id),
    params,
  );
  return response.data;
};

export const exportPensionIrelandApi = async (
  params: ExportPensionIrelandParams,
): Promise<ExportPensionIrelandResponse> => {
  const response = await axios.get(
    endPoints.report.pension.exportPensionIreland,
    { params },
  );
  return response.data;
};

export const getEarningStatementListApi = async (
  params: GetEarningStatementListParams,
): Promise<GetEarningStatementListResponse> => {
  const response = await axios.get(
    endPoints.report.management.earningInSubPortalV2,
    { params },
  );
  return response.data;
};

export const exportEarningStatementApi = async (
  params: ExportEarningStatementParams,
): Promise<ExportEarningStatementResponse> => {
  const response = await axios.put(
    endPoints.report.management.exportEarningInSub,
    {},
    { params },
  );
  return response.data;
};